import { render, staticRenderFns } from "./suggestionsListStaffPicksAdder.vue.html?vue&type=template&id=a1cc5b68&"
import script from "./suggestionsListStaffPicksAdder.ts?vue&type=script&lang=ts&"
export * from "./suggestionsListStaffPicksAdder.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports